import './Notifications.css';

import { Component } from 'react';
import { hideNotification, removeNotification } from './actions';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Message from './Message';
import { makeSelectMessages } from './selectors';

class NotificationsToaster extends Component {
  static propTypes = {
    messages: ImmutablePropTypes.list.isRequired,
    onHideNotification: PropTypes.func.isRequired,
    onRemoveNotification: PropTypes.func.isRequired,
  };

  getMessage = (index, notification) => {
    const { onHideNotification, onRemoveNotification } = this.props;
    const message = notification.get('message');
    return (
      <Message
        text={message}
        first={index === 0}
        hash={notification.get('hash')}
        key={notification.get('hash')}
        onHideNotification={onHideNotification}
        onRemoveNotification={onRemoveNotification}
        title={notification.get('title')}
        type={notification.get('type')}
        time={notification.get('time')}
      />
    );
  };

  render() {
    const { messages } = this.props;
    return (
      <div className='notifications__wrapper'>
        {messages.map((message, index) =>
          message.get('show') ? this.getMessage(index, message) : null,
        )}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  messages: makeSelectMessages(),
});

function mapDispatchToProps(dispatch) {
  return {
    onHideNotification: (args) => dispatch(hideNotification(args)),
    onRemoveNotification: (args) => dispatch(removeNotification(args)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsToaster);
